import PageMeta from "components/PageMeta";
import { Account } from "models/Account";
import { Invoice } from "models/Invoice";
import { Project } from "models/Project";
import { Tenant } from "models/Tenant";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Card, CardBody } from "reactstrap";
import * as api from "services/Api";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import ProjectPayoutOverview from "./ProjectPayoutOverview";
import "./project-detail.scss";

const ProjectPayments: React.FC = () => {
    const { t } = useOfficeTranslation();
    const [projects, setProjects] = useState<Project[]>([]);
    const [accounts, setAccounts] = useState<Account[]>([]);
    const [invoices, setInvoices] = useState<Invoice[]>([]);
    const [tenants, setTenants] = useState<Tenant[]>([]);
    const [loading, setLoading] = useState(true);
    const [loadFailed, setLoadFailed] = useState(false);

    useEffect(() => {
        Promise.all([api.getProjects(), api.getAccounts(), api.getInvoices(), api.getTenants()])
            .then(([projectValues, accountValues, invoiceValues, tenantValues]) => {
                setProjects(projectValues);
                setAccounts(accountValues);
                setInvoices(invoiceValues);
                setTenants(tenantValues);
            })
            .catch(() => setLoadFailed(true))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="page-content">
            <PageMeta title={t("projects.projectPayments.title")} />

            <div className="page-title-box d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div>
                    <h4 className="mb-1">{t("projects.projectPayments.title")}</h4>
                    <p className="text-muted mb-0">{t("projects.projectPayments.description")}</p>
                </div>
                <Link className="btn btn-light" to="/projects">
                    <i className="mdi mdi-arrow-left me-1" />
                    {t("projects.projectPayments.backToProjects")}
                </Link>
            </div>

            {loading &&
                <Card>
                    <CardBody>
                        <p className="text-muted text-center py-5 mb-0">
                            {t("projects.projectPayments.loading")}
                        </p>
                    </CardBody>
                </Card>
            }

            {!loading && loadFailed &&
                <Alert color="danger">{t("projects.projectPayments.loadFailed")}</Alert>
            }

            {!loading && !loadFailed &&
                <ProjectPayoutOverview
                    projects={projects}
                    accounts={accounts}
                    invoices={invoices}
                    tenants={tenants}
                    onInvoiceUpdated={updatedInvoice => setInvoices(current => current.map(invoice =>
                        invoice.id === updatedInvoice.id ? updatedInvoice : invoice
                    ))}
                />
            }
        </div>
    );
};

export default ProjectPayments;
